export default {
    cn: {
        ibCommission: {
            unconfirmed: '未审核的',
            confirmed: '已审核的',
            contrastBrowse: '对比浏览',
            singlepageBrowse: '单页浏览',
            updateBy: '最后修改',
            confirmBy: '最后审核',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基础模板',
            alertMsg: {
                noAccount: '这不是一个正确的账号',
                checkFail: '不能由同一人完成修改和审核',
                verifyTips: '是否确定审核，如果数据有修改，请先保存，否则将被覆盖!',
                beforeSave: '请先保存数据',
                checkRuleFail1: '存在“分层最高金额”这个规则设定时，加点、外佣、内返的值必须相同',
                checkRuleFail2: '存在“分层最高金额”这个规则时，每个级别都必须有一条相同的“分层最高金额”，并保证“加点、外佣、内返”一致',
                templateExist: '模板名已存在!',
            },
            ibCommissionPreview: {
                ibCommissionPreview: '代理佣金预览',
                lowerIBCommissionPreview: '下级代理佣金预览',
                specialIBCommissionPreview: '特别代理佣金预览',
                unit: 'USD',
                mainIb: '主代理',
                subIb: '子代理',
                th: {
                    ibType: '代理类型',
                    ibAccount: '代理账号',
                    ibName: '代理姓名',
                    CommissionReturn: '代理获得的佣金',
                    subIBAccount: '子代理账号',
                    mainIBAccount: '主代理账号',
                    getSubCondition: '主代理获取子代理的条件',
                    additionAmount: '额外金额',
                    specialIBAccount: '特别代理账号',
                    originalMainAccount: '原主账号',
                    getSpecialCondition: '收拥代理获取特别代理的条件'
                },
                rules: {
                    subIB: '子代理的',
                    spreadCommission: '加点',
                    externalCommission: '外佣',
                    internalCommission: '内返',
                    exceptant: '以外的',
                    after: '之后的',
                    differenceForMaxInternalCommission: '与最高内返差值给上一层账号',
                    everyTransactionByFixedamount: '每手按照固定金额',
                    toTargetIB: '返给指定代理',
                    exceedTO: '每手如果超过以下金额，余下全部给上一层账号',
                    forex: '外汇',
                    gold: '黄金',
                    silver: '白银',
                    energy: '能源',
                    index: '指数',
                }
            },
            commissionRule: '佣金规则',
            ruleCommission: {
                pleaseChooseSubIB: '请选择子代理的',
                pleaseHandleSubIB: '请把子代理的',
                spreadCommission: '加点',
                externalCommission: '外佣',
                internalCommission: '内返',
                partOf: '部分的',
                toUpperAccount: '给上一层账号',
                differenceForMaxInternalCommission: '与最高内返差值给上一层账号',
                everyTransactionByFixedamount: '每手按照固定金额',
                toTargetIB: '返给指定代理',
                exceedTO: '每手如果超过以下金额，余下全部给上一层账号'
            },
            upperCommission: {
                upperTitle: '分配去上层账号',
                targetTitle: '分配去指定账号',
                targetPlaceholder: '请输入账号',
                noUpperIB: '没有上层代理'
            },
            reminderDate: '到期时间',
            reminderMsg: '到期提示信息',
            reminderMsgPlaceholder: '请输入内容',
            choiceDateTime: '请选择日期时间',
            sented: '已发送',
            ibAccount: '代理账号',
            ibcAccount: "收佣账号",
            ibCommissionSetting: '代理佣金设定',
            upperCommissiondistribution: '多层佣金分配',
            submitResult: {
                err: '请正确填写信息',
                succeed: '保存成功',
                auditSuccess: '审核成功',
                serverErr: '提交失败'
            },
            crumbs: {
                amend: "佣金修改",
            },
            enable: '启用',
            specialCommission: '特殊返佣',
            infinite: '以上',
            to: '至',
            or: '至',

            commonCaculation: '内返计算',
            CPACaculation: 'CPA计算',
            comAndCPA: '内返 + CPA计算',
            CPACommission: 'CPA返拥',

            SettingTemplate: '设定模版',
            ib_allTemplate: '全部模版',
            ib_default: '标准内返',
            ib_max: '高标准内返',
            ib_min: '低标准内返',
            ib_second_level: '第二层开始',
            ib_minus_1: '减一内返',
            ib_minus_2: '减二内返',
            ib_plus2: '加二内返',
            ib_max12upper: '高标 12 USD(一级代理)',
            ib_max12lower: '高标 12 USD(子代理)',
            ib_default12: '12 USD',
            ib_subib_plana: '下层代理计划 A',
            ib_subib_planb: '下层代理计划 B',
            ib_subib_planc: '下层代理计划 C',
            ib_egypt_masterplan: '埃及标准内返',
            ib_extra5: '额外5%',

            ib_8_9_10_from3to2: '8,9,10 (三级返二级)',
            ib_8_9_10_from3to2and1: '8,9,10 (三级返二级一级)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: '与 12 USD 差值返回一级代理',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (返上层 1 USD)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (返上层 1 USD)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (返上层 2 USD)',
            ib_7_8_9_10: '7,8,9,10 (返上二层各 1 USD)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 层代理计划',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: '微型帐户代理返佣',
            ib_08_09_10_11: '微型帐户代理返佣(二级)',
            ib_07_08_09_10: '微型帐户代理返佣(三级)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: '韩国代理',
            ib_8_upper_4: '固8返上4',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (返第一层 3 USD)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (返第二层 3 USD)',
            ib_4_5_6_7_2lvl: '4,5,6,7(返二级3,返一级2)(泰国专用)',
            ib_5_6_7_8_1lvl: '5,6,7,8(返上层4USD)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(返二级1,返一级4)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(返二级2,返一级3)',
            ib_7_8_9_10_1lvl_spread: '7.8.9.10 (返上层 2 USD),加点返到主代理',
            ib_7_8_9_10_2lvl_spread: '7.8.9.10 (返上二层各 1 USD),加点返到主代理',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (二级固定2)',
            ib_spread_1: '加 0.1 点返佣',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (返上层 2 USD)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% 下层 2',
            ib_sub_50p_3: '50% 下层 3',

            cpa_SettingTemplate: 'CPA 设定模板',
            cpa_default: '标准CPA',
            cpa_min: '低标准CPA',
            cpa_max: '高标准CPA',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',


            CPA: {
                totalVolume: '总成交量',
                LOT: '手数',
                remarks: '当月符合条件的客户数目',
                commissionPer: '每个客户佣金',
            },
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '删除',
                addLots: '添加手数',
                removeLots: '删除手数',
                confirmDeleteText: '确认删除所选记录吗？',
                commissionPreviewBtn: '佣金预览',
                back: '返回',
                addLevel: '添加级别',
                removeLevel: '删除级别',
                check: '确认审核',
                backData: '返回之前数据'
            },
            thead: {
                lots: '手数 \/ 产品',
                operation: '操作',
            }
        }
    },
    hk: {
        ibCommission: {
            unconfirmed: '未審核的',
            confirmed: '已審核的',
            contrastBrowse: '對比瀏覽',
            singlepageBrowse: '單頁瀏覽',
            updateBy: '最后修改',
            confirmBy: '最后審核',
            templateSetting: '模板管理',
            templateName: '模板名称',
            templateHistory: '模板历史',
            templateCreate: '新建模板',
            templateBase: '基礎模板',
            alertMsg: {
                noAccount: '這不是一個正確的賬號',
                checkFail: '不能由同一人完成修改和審核',
                verifyTips: '是否確定審核，如果數據有修改，請先保存，否則將被覆蓋!',
                beforeSave: '請先保存數據',
                checkRuleFail1: '存在“分層最高金額”這個規則設定時，加點、外佣、內返的值必須相同',
                checkRuleFail2: '存在“分層最高金額”這個規則時，每個級別都必須有一條相同的“分層最高金額”，并保證“加點、外佣、內返”一致',
                templateExist: '模板名已存在!',
            },
            ibCommissionPreview: {
                ibCommissionPreview: '代理佣金預覽',
                lowerIBCommissionPreview: '下級代理佣金預覽',
                specialIBCommissionPreview: '特別代理佣金預覽',
                unit: 'USD',
                mainIb: '主代理',
                subIb: '子代理',
                th: {
                    ibType: '代理類型',
                    ibAccount: '代理賬號',
                    ibName: '代理姓名',
                    CommissionReturn: '代理獲得的佣金',
                    subIBAccount: '子代理賬號',
                    mainIBAccount: '主代理賬號',
                    getSubCondition: '主代理獲取子代理的條件',
                    additionAmount: '額外金額',
                    specialIBAccount: '特別代理賬號',
                    originalMainAccount: '原主賬號',
                    getSpecialCondition: '收拥代理獲取特別代理的條件'
                },
                rules: {
                    subIB: '子代理的',
                    spreadCommission: '加點',
                    externalCommission: '外佣',
                    internalCommission: '內返',
                    exceptant: '以外的',
                    after: '之后的',
                    differenceForMaxInternalCommission: '與最高內返差值給上一層賬號',
                    everyTransactionByFixedamount: '每手按照固定金額',
                    toTargetIB: '返給指定代理',
                    exceedTO: '每手如果超過以下金額，余下全部給上一層賬號',
                    forex: '外匯',
                    gold: '黃金',
                    silver: '白銀',
                    energy: '能源',
                    index: '指數',
                }
            },
            commissionRule: '佣金規則',
            ruleCommission: {
                pleaseChooseSubIB: '請選擇子代理的',
                pleaseHandleSubIB: '請把子代理的',
                spreadCommission: '加點',
                externalCommission: '外佣',
                internalCommission: '內返',
                partOf: '部分的',
                toUpperAccount: '給上一層賬號',
                differenceForMaxInternalCommission: '與最高內返差值給上一層賬號',
                everyTransactionByFixedamount: '每手按照固定金額',
                toTargetIB: '返給指定代理',
                exceedTO: '每手如果超過以下金額，余下全部給上一層賬號'
            },
            upperCommission: {
                upperTitle: '分配去上層賬號',
                targetTitle: '分配去指定賬號',
                targetPlaceholder: '請輸入賬號',
                noUpperIB: '沒有上層代理'
            },
            reminderDate: '到期時間',
            reminderMsg: '到期提示信息',
            reminderMsgPlaceholder: '請輸入內容',
            choiceDateTime: '請選擇日期時間',
            sented: '已發送',
            ibAccount: '代理賬號',
            ibcAccount: "收佣賬號",
            ibCommissionSetting: '代理佣金設定',
            upperCommissiondistribution: '多層佣金分配',
            submitResult: {
                err: '請正確填寫信息',
                succeed: '保存成功',
                auditSuccess: '審核成功',
                serverErr: '提交失敗'
            },
            crumbs: {
                amend: "佣金修改",
            },
            enable: '啟用',
            specialCommission: '特殊返佣',
            infinite: '以上',
            to: '至',
            or: '至',
            commonCaculation: '內返計算',
            CPACaculation: 'CPA計算',
            comAndCPA: '內返 + CPA計算',
            CPACommission: 'CPA返佣',


            SettingTemplate: '設定模板',
            ib_allTemplate: '全部模版',
            ib_default: '標準內返',
            ib_max: '高標準內返',
            ib_min: '低標準內返',
            ib_second_level: '第二層開始',
            ib_minus_1: '減一內返',
            ib_minus_2: '減二內返',
            ib_plus2: '加二內返',
            ib_max12upper: '高標 12 USD(一級代理)',
            ib_max12lower: '高標 12 USD(子代理)',
            ib_default12: '12 USD',
            ib_subib_plana: '下層代理計劃 A',
            ib_subib_planb: '下層代理計劃 B',
            ib_subib_planc: '下層代理計劃 C',
            ib_egypt_masterplan: '埃及標準內返',
            ib_extra5: '額外5%',

            ib_8_9_10_from3to2: '8,9,10 (三級返二級)',
            ib_8_9_10_from3to2and1: '8,9,10 (三級返二級一級)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: '与 12 USD 差值返回一级代理',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (返上層 1 USD)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (返上層 1 USD)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (返上層 2 USD)',
            ib_7_8_9_10: '7,8,9,10 (返上二層各 1 USD)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 層代理計劃',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: '微型帳戶代理返佣',
            ib_08_09_10_11: '微型帐户代理返佣(二級)',
            ib_07_08_09_10: '微型帐户代理返佣(三級)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: '韓國代理',
            ib_8_upper_4: '固8返上4',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (返第一層 3 USD)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (返第二層 3 USD)',
            ib_4_5_6_7_2lvl: '4,5,6,7(返二級3,返一級2)(泰國專用)',
            ib_5_6_7_8_1lvl: '5,6,7,8(返上層4USD)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(返二級1,返一級4)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(返二級2,返一級3)',
            ib_7_8_9_10_1lvl_spread: '7.8.9.10 (返上層 2 USD),加點返到主代理',
            ib_7_8_9_10_2lvl_spread: '7.8.9.10 (返上二層各 1 USD),加點返到主代理',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (二級固定2)',
            ib_spread_1: '加 0.1 點返佣',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (返上層 2 USD)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% sub 2',
            ib_sub_50p_3: '50% sub 3',

            cpa_SettingTemplate: 'CPA 設定模板',
            cpa_default: '標準CPA',
            cpa_min: '低標準CPA',
            cpa_max: '高標準CPA',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',

            CPA: {
                totalVolume: '總成交量',
                LOT: '手數',
                remarks: '當月符合條件的客戶數目',
                commissionPer: '每個客戶佣金',
            },
            btnGroup: {
                submit: '保存修改',
                add: '添加',
                remove: '刪除',
                addLots: '添加手數',
                removeLots: '刪除手數',
                confirmDeleteText: '確認刪除所選記錄嗎？',
                commissionPreviewBtn: '佣金預覽',
                back: '返回',
                addLevel: '添加級別',
                removeLevel: '刪除級別',
                check: '確認審核',
                backData: '返回之前數據'
            },
            thead: {
                lots: '手數 \/ 產品',
                operation: '操作',
            }
        }
    },
    en: {
        ibCommission: {
            unconfirmed: 'unconfirmed',
            confirmed: 'confirmed',
            contrastBrowse: 'Contrast Browse',
            singlepageBrowse: 'Singlepage Browse',
            updateBy: 'UpdateBy',
            confirmBy: 'ConfirmBy',
            templateSetting: 'Template Maintenance',
            templateName: 'Template Name',
            templateHistory: 'Template History',
            templateCreate: 'New Template',
            templateBase: 'Base Template',
            alertMsg: {
                noAccount: 'Invalid Account',
                checkFail: 'Can not check Modification and inspection by same person',
                verifyTips: 'Whether to confirm audit, if the data has been modified, please save first, otherwise it will be overwritten!',
                beforeSave: 'Please save the data first',
                checkRuleFail1: 'Check Rule Setting Fail :  1',
                checkRuleFail2: 'Check Rule Setting Fail :  2',
                templateExist: 'Template Name Already Exist!',
            },
            ibCommissionPreview: {
                ibCommissionPreview: 'IB Commission Setting Preview',
                lowerIBCommissionPreview: 'Lower IB Commission Preview',
                specialIBCommissionPreview: 'Special IB Commission Preview',
                unit: 'USD',
                mainIb: 'Main IB',
                subIb: 'Sub IB',
                th: {
                    ibType: 'IB Type',
                    ibAccount: 'IB Account',
                    ibName: 'IB Name',
                    CommissionReturn: 'Commission Rebate',
                    subIBAccount: 'Sub IB Account',
                    mainIBAccount: 'Main IB Account',
                    getSubCondition: 'The condition to Main IB',
                    additionAmount: 'Extra Amount',
                    specialIBAccount: 'Special IB Account',
                    originalMainAccount: 'Original Main Account',
                    getSpecialCondition: 'The condition to IB Account'
                },
                rules: {
                    subIB: 'Sub IB',
                    spreadCommission: 'Spread Commission',
                    externalCommission: 'External Commission',
                    internalCommission: 'Internal Commission',
                    exceptant: 'Exceptant',
                    after: 'After',
                    differenceForMaxInternalCommission: 'Difference to max rebate level',
                    everyTransactionByFixedamount: 'Fixed Amount per lot',
                    toTargetIB: 'To Target IB',
                    exceedTO: 'If per lot commission exceed the defined amount, the remaining to upper account',
                    forex: 'Forex',
                    gold: 'Gold',
                    silver: 'Silver',
                    energy: 'Energy',
                    index: 'Index',
                }
            },
            commissionRule: 'Commission Rule',
            ruleCommission: {
                pleaseChooseSubIB: 'Please Choose Sub IB',
                pleaseHandleSubIB: 'Please Handle Sub IB',
                spreadCommission: 'Spread Commission',
                externalCommission: 'External Commission',
                internalCommission: 'Internal Commission',
                partOf: 'Part of',
                toUpperAccount: 'To Upper Account',
                differenceForMaxInternalCommission: 'Difference to max rebate level',
                everyTransactionByFixedAmount: 'Fixed Amount per lot',
                toTargetIB: 'To Target IB',
                exceedTO: 'If per lot commission exceed the defined amount, the remaining to upper account'
            },
            upperCommission: {
                upperTitle: 'Distribution to Upper IB Account',
                targetTitle: 'Distribution to Direct Account',
                targetPlaceholder: 'Please Input The Account',
                noUpperIB: 'No Upper IB'
            },
            reminderDate: 'Reminder Date',
            reminderMsg: 'Reminder Message',
            reminderMsgPlaceholder: 'Please Enter',
            choiceDateTime: 'Please choose datetime',
            sented: 'Sent',
            ibAccount: 'IB Account',
            ibcAccount: "Commission Account",
            ibCommissionSetting: 'IB Commission Setting',
            upperCommissiondistribution: 'More Commission Distribution',
            submitResult: {
                err: 'Please fill in the information correctly',
                succeed: 'Save Successfully',
                auditSuccess: 'Check Successfully',
                serverErr: 'Submit failed!'
            },
            crumbs: {
                amend: "Amend Commission",
            },
            enable: 'Enable',
            specialCommission: 'Special Commission',
            infinite: 'infinity',
            to: 'to',
            or: 'to',
            commonCaculation: 'Internal Commission Calculation',
            CPACaculation: 'CPA Caculation',
            comAndCPA: 'Internal Commission + CPA Caculation',
            CPACommission: 'CPA Commission',


            SettingTemplate: 'Setting Template',
            ib_allTemplate: 'All Template',
            ib_default: 'Standard Rebate',
            ib_max: 'High Internal Commission Calculation',
            ib_min: 'Low Internal Commission Calculation',
            ib_second_level: 'Second level',
            ib_minus_1: 'Minus One Internal Commission',
            ib_minus_2: 'Minus Two Internal Commission',
            ib_plus2: 'Plus 2 Rebate',
            ib_max12upper: 'Highest 12 (1st Level IB)',
            ib_max12lower: 'Highest 12 (Sub IB)',
            ib_default12: '12 USD',
            ib_subib_plana: 'Sub IB Plan A',
            ib_subib_planb: 'Sub IB Plan B',
            ib_subib_planc: 'Sub IB Plan C',
            ib_egypt_masterplan: 'Egypt Standard Rebate',
            ib_extra5: 'Extra 5%',

            ib_8_9_10_from3to2: '8,9,10 (From Lv3 to Lv2)',
            ib_8_9_10_from3to2and1: '8,9,10 (From Lv3 to Lv2 and Lv1)',
            ib_8_9_10: '8,9,10',
            ib_9_10: '9,10',
            ib_10_11_12: '10,11,12',
            ib_8: '8 USD',
            ib_10: '10 USD',
            ib_12: '12 USD',
            ib_12_diff: 'Diff with 12 USD to upper IB',
            ib_9_10_11_12: '9,10,11,12',
            ib_sea_9: 'SEA 9 USD',
            ib_sea_12: 'SEA 12 USD',
            ib_8_9_10_11: '8,9,10,11 (1 USD to upper)',
            ib_9_10_11_12_1lvl_1: '9,10,11,12 (1 USD to upper)',
            ib_7_8_9_10_1lvl: '7,8,9,10 (2 USD to upper)',
            ib_7_8_9_10: '7,8,9,10 (1 USD to 2 upper level)',
            ib_uae_5_6_7: 'UAE 5,6,7',
            ib_uae_7_8_9: '7,8,9',
            ib_uae_1_2_3_variable: '1,2,3 Variable',
            ib_egy_5_6_7: 'EGY 5,6,7',
            ib_5_6_7: '5,6,7',
            ib_5: '5 USD',
            ib_7: '7 USD',
            ib_3_level_plan: '3 Level Plan',
            ib_uae_8: '8 USD',
            ib_4_5_6: '4,5,6',
            ib_09_10_11_12: 'Mini IB Rebate',
            ib_08_09_10_11: 'Mini IB Rebate (2 Level)',
            ib_07_08_09_10: 'Mini IB Rebate (3 Level)',
            ib_tw_1st: 'TW VIP(MIB)',
            ib_tw_2nd: 'TW VIP(SUB IB)',
            ib_edge_1st: 'Edge for MIB',
            ib_edge_2nd: 'Edge for 2 SUB IB',
            ib_edge_3rd: 'Edge for 3 SUB IB',
            ib_kr: 'Korea IB',
            ib_8_upper_4: '8 USD Only and 4 to upper',
            ib_tw_3rd: 'TW VIP(SUB2 IB)',
            ib_6_7_8_9_1lvl: '6,7,8,9 (3 USD to 1st)',
            ib_6_7_8_9_2lvl: '6,7,8,9 (3 USD to 2nd)',
            ib_4_5_6_7_2lvl: '4,5,6,7(3 to 2nd,2 to 1st)(For Thailand)',
            ib_5_6_7_8_1lvl: '5,6,7,8(4 USD to upper)',
            ib_4_5_6_7_2lvl_1_4: '4,5,6,7(1 to 2nd,4 to 1st)',
            ib_4_5_6_7_2lvl_2_3: '4,5,6,7(2 to 2nd,3 to 1st)',
            ib_7_8_9_10_1lvl_spread: '7,8,9,10 (2 USD to upper),spread to Master',
            ib_7_8_9_10_2lvl_spread: '7,8,9,10 (1 to 2nd,1 to 1st),spread to Master',
            ib_7_8_9_10_2lvl_fix2: '7,8,9,10 (Fix 2 to 2nd)',
            ib_spread_1: 'Add 0.1 pips rebate',
            ib_ia_option1: 'OPTION 1 (USD)',
            ib_ia_option2: 'OPTION 2 (USD)',
            ib_ia_option3: 'OPTION 3 (USD)',
            ib_ia_spread: 'SPREAD (USD)',
            ib_ia_option1_eur: 'OPTION 1 (EUR)',
            ib_ia_option2_eur: 'OPTION 2 (EUR)',
            ib_ia_option3_eur: 'OPTION 3 (EUR)',
            ib_ia_spread_eur: 'SPREAD (EUR)',
            ib_ia_option1_gbp: 'OPTION 1 (GBP)',
            ib_ia_option2_gbp: 'OPTION 2 (GBP)',
            ib_ia_option3_gbp: 'OPTION 3 (GBP)',
            ib_ia_spread_gbp: 'SPREAD (GBP)',
            ib_ia_premium_raw_eur: 'Premium raw(EUR)',
            ib_ia_raw30: 'RAW 30',
            ib_ia_raw13: 'RAW 13',
            ib_ia_raw50: 'RAW 50',
            ib_ia_edge5: 'EDGE 5',
            ib_05prem: '05Prem',
            ib_8_9_10_1lvl_2: '8,9,10 (2 USD to upper)',
            ib_mx_option1: 'OPTION 1',
            ib_mx_option2: 'OPTION 2',
            ib_mx_option3: 'OPTION 3',
            ib_mx_option4: 'OPTION 4 (Markup)',
            ib_mx_50sub: '50% Sub',
            ib_mx_level3: 'LEVEL 3',
            ib_680005729: 'SIB under MIB 680005729',
            ib_ecn: 'ECN',
            ib_vn_ecn: 'VN ECN',
            ib_sub_50p_2: '50% sub 2',
            ib_sub_50p_3: '50% sub 3',

            cpa_SettingTemplate: 'CPA Setting Template',
            cpa_default: 'Standard CPA',
            cpa_min: 'Low CPA Caculation',
            cpa_max: 'High CPA Caculation',

            cpa_20_25_30: '20,25,30',
            cpa_200_250_300: '200,250,300',

            CPA: {
                totalVolume: 'Total Volume',
                LOT: 'LOT',
                remarks: 'No of client per month amount',
                commissionPer: 'Commission per head count',
            },
            btnGroup: {
                submit: 'Save',
                add: 'Add',
                remove: 'Remove',
                addLots: 'Add Lots',
                removeLots: 'Remove Lots',
                confirmDeleteText: 'Are you sure to delete the selected record ?',
                commissionPreviewBtn: 'Commission Preview',
                back: 'Back',
                addLevel: 'Add Level',
                removeLevel: 'Remove Level',
                check: 'Check',
                backData: 'Return Data'
            },
            thead: {
                lots: 'Lots \/ Products',
                operation: 'Operation',
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/ibCommission.js